export const ALL_PROJECTS = 'ALL_PROJECTS';
export const SPECIFIC_PROJECTS = 'SPECIFIC_PROJECTS';

export const PROJECT_ACCESS_TYPES = [
  [ALL_PROJECTS, 'All projects'],
  [SPECIFIC_PROJECTS, 'Specific projects'],
];
